import { useComputedColorScheme } from "@mantine/core";
import wordmark from "../../assets/brand/wordmark.png";
import wordmarkDark from "../../assets/brand/wordmark-dark.png";

/**
 * The SMART SAFIRI wordmark from the apps' logo artwork. Light theme uses the
 * full-colour lockup (oxblood A + SAFIRI); dark theme uses the white/mist
 * lockup, since oxblood artwork is 1.64:1 on the dark shell (colour spec).
 */
export function BrandLogo({ height = 28 }: { height?: number }) {
  const scheme = useComputedColorScheme("light");
  return (
    <img
      src={scheme === "dark" ? wordmarkDark : wordmark}
      alt="Smart Safiri"
      draggable={false}
      style={{ height, width: "auto", display: "block", alignSelf: "flex-start", flexShrink: 0 }}
    />
  );
}
